import { CurrencyPipe, registerLocaleData } from '@angular/common';
import localeEsCo from '@angular/common/locales/es-CO';
registerLocaleData(localeEsCo)
const CONF_DECIMALS = '1.0'; // '1.2-2';
export const parsedValueToCop = (value: string) => {
    return '$ ' + new CurrencyPipe('es-CO').transform(value, 'COP', '', CONF_DECIMALS);
};
